import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SelectControl } from '../ui/controls/select-control.model';
import { UrlHelperService } from '@core/services/url-helper.service';

/**
 *
 * Handle our select field lookups
 *
 * */

@Injectable({
  providedIn: 'root'
})
export class SelectLookupService {

  constructor(private http: HttpClient, private urlService: UrlHelperService) { }

  lookup(select: SelectControl): any {
    var url = this.buildUrl(select);
    return this.http.get(url);
  }

  private buildUrl(select: SelectControl): string {
    var url = this.urlService.getApiUrl();
    url += select.apiController;

    var filters = select.filters;

    var c = 0;
    for (var key in filters) {
      var value = Reflect.get(filters, key);
      if (value !== undefined && value !== null) {
        var urlSeparator = c == 0 ? "?" : "&";
        url += urlSeparator + key + "=" + value;
      }
      c++;
    }

    return url;
  }

}
